module.exports = __webpack_public_path__ + "img/pub-info.2783081a.png";